module.exports = __webpack_public_path__ + "static/media/mieloma-home.1bd3745c.jpg";